<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12" xl="12">
                <Base :widget="model" v-bind:key="key" />
            </b-col>
            <b-col cols="12" xl="12">
                <transition name="slide">
                    <b-card>
                        <b-form @submit="save">

                            <InputField name="name" :label="this.$t('title')" v-model="model.title" @error="fieldError"
                                :rules="{ required: true, length: { min: 2 } }" />

                            <InputField name="description" :label="this.$t('description')" v-model="model.description"
                                @error="fieldError" :rules="{ length: { min: 5 }, required: model.type == 'TextBox' }" />

                            <SelectField name="type" :label="this.$t('type')" v-model="model.type" @error="fieldError"
                                :items="['TextBox', 'Default', 'Standard', 'StandardFullIcon']"
                                :rules="{ required: true }" />

                            <SelectField name="component" :label="this.$t('component')" v-model="model.component"
                                @error="fieldError" :items="componentList" :rules="{ required: model.type != 'TextBox' }"
                                v-if="model.type != 'TextBox'" />

                            <SelectField name="variant" :label="this.$t('variant')" v-model="model.variant"
                                @error="fieldError" :description="this.$t('widgetColor')" :items="variants"
                                :rules="{ required: false }" />


                            <b-form-group :label="this.$t('formatter')" label-for="formatter" :label-cols="2"
                                :description="model.type != 'TextBox' ? '' : 'Formatter can\'t be set for TextBox widget type'"
                                :horizontal="false">
                                <div class="form-actions" v-if="model.type != 'TextBox'">
                                    <b-button variant="primary" @click="formatterModal.show = true">Open
                                        Editor</b-button>
                                </div>
                                <main-dialog size="lg" title="Formatter editor" v-model="formatterModal.show">
                                    <InputField type="number" name="limit" :label="this.$t('limit')"
                                        v-model.number="model.formatter.limit" @error="fieldError"
                                        :description="this.$t('limitOfModels')" :rules="{ required: true }" />

                                    <InputField type="text" name="filter" :label="this.$t('filter')"
                                        v-model="model.formatter.filter" @error="fieldError"
                                        :description="this.$t('searchField')" :rules="{ required: false }" />

                                    <b-form-group :label="this.$t('filterOn')" :label-cols="2" :horizontal="false"
                                        :description="this.$t('filterModels')">
                                        <b-form-checkbox-group id="filter-on-fields" v-model="model.formatter.filterOn"
                                            :options="filterOnFields" name="filterOn"></b-form-checkbox-group>
                                    </b-form-group>

                                    <b-form-group :label="this.$t('disabled')" :label-cols="2" :horizontal="false"
                                        :description="this.$t('returnDisabled')">
                                        <c-switch class="mx-1" color="success" variant="pill"
                                            v-model="model.formatter.disabled" />
                                    </b-form-group>

                                    <CodeEditor v-model="model.formatter.code"
                                        editor_description="returned value will be displayed in widget"
                                        :label="this.$t('expression')" :label-cols="2" :horizontal="true" :libs="libs"
                                        :vars="vars" />
                                </main-dialog>
                            </b-form-group>
                            <b-form-group :label="this.$t('progressBar')" :label-cols="2" :horizontal="false"
                                :description="model.type == 'Default' ? '' : 'Progress bar can be modified just when widget type is \'Default\''">
                                <div class="form-actions" v-if="model.type == 'Default'">
                                    <b-button variant="primary" @click="progressBarModal.show = true">{{
                                        $t('openEditor') }}</b-button>
                                </div>
                                <main-dialog size="md" title="Progress Bar editor" v-model="progressBarModal.show">
                                    <b-form-group :label="this.$t('display')" :label-cols="2" :horizontal="false">
                                        <c-switch class="mx-1" color="success" variant="pill"
                                            v-model="model.progressBar.bar" />
                                    </b-form-group>

                                    <SelectField name="variant" :label="this.$t('variant')" v-model="model.icon.variant"
                                        @error="fieldError" :items="variants" :rules="{ required: false }" />

                                    <CodeEditor v-model="model.progressBar.formatter"
                                        editor_description="calculations are counted towards progress bar"
                                        :label="this.$t('formatter')" :label-cols="2" :horizontal="true" :libs="libs"
                                        :vars="vars" />
                                </main-dialog>

                            </b-form-group>
                            <b-form-group :label="this.$t('icon')" :label-cols="2" :horizontal="false"
                                :description="model.type != 'TextBox' ? '' : 'Icon can\'t be set for TextBox widget type'">
                                <div class="form-actions" v-if="model.type != 'TextBox'">
                                    <b-button variant="primary" @click="iconModal.show = true">{{ $t('openEditor')
                                        }}</b-button>
                                </div>
                                <main-dialog size="md" title="Icon editor" v-model="iconModal.show">

                                    <SelectField name="position" :label="this.$t('position')" v-model="model.icon.type"
                                        @error="fieldError" :items="['left', 'right']" :rules="{ required: false }"
                                        v-if="model.type == 'Default'" />

                                    <Appearance v-model="model.icon.value" :description="this.$t('iconWidget')" />

                                    <SelectField name="icon_variant" :label="this.$t('variant')"
                                        v-model="model.icon.variant" @error="fieldError" :items="variants"
                                        :rules="{ required: (model.type == 'StandardFullIcon') }"
                                        v-if="model.type != 'Default'" />
                                </main-dialog>

                            </b-form-group>
                            <b-form-group :label="this.$t('size')" label-for="size" :label-cols="2" :horizontal="false">
                                <div class="form-actions">
                                    <b-button variant="primary" @click="sizeModal.show = true">{{ $t('openEditor')
                                        }}</b-button>
                                </div>
                                <main-dialog size="md" title="Size editor" v-model="sizeModal.show">

                                    <InputField type="number" name="sm" :label="this.$t('mobile')"
                                        v-model.number="model.size.sm" @error="fieldError"
                                        :rules="{ length: { min: 1, max: 12 } }" />

                                    <InputField type="number" name="md" :label="this.$t('tablet')"
                                        v-model.number="model.size.md" @error="fieldError"
                                        :rules="{ length: { min: 1, max: 12 } }" />

                                    <InputField type="number" name="lg" :label="this.$t('desktop')"
                                        v-model.number="model.size.lg" @error="fieldError"
                                        :rules="{ length: { min: 1, max: 12 } }" />
                                </main-dialog>
                            </b-form-group>
                            <b-form-group :label="this.$t('active')" :label-cols="2" :horizontal="false">
                                <c-switch class="mx-1" color="success" variant="pill" v-model="model.is_active" />
                            </b-form-group>

                            <div class="form-actions float-right">
                                <b-button type="submit" variant="success">{{ $t('saveChanges') }}</b-button>
                            </div>
                        </b-form>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { deepCopyObject } from '../../shared/utils'
import { Switch as cSwitch } from '@coreui/vue'
import Appearance from '../../components/base/Settings/Appearance'

import Code from "@/components/form/Editor/Code"

import Input from "@/components/form/Input"
import Select from "@/components/form/Select"

import Base from "../../components/widgets/Base"

export default {
    name: "Create",
    components: {
        InputField: Input,
        SelectField: Select,
        CodeEditor: Code,
        cSwitch,
        Appearance,
        Base
    },
    data: function () {
        return {
            key: 1,
            errors: [],
            progressBarModal: {
                show: false,
                formatterModal: {
                    show: false,
                    options: {
                        tabSize: 4,
                        lineNumbers: true,
                        line: true,
                        autoRefresh: true,
                        foldGutter: true,
                        styleSelectedText: true,
                        mode: 'text/javascript',
                        matchBrackets: true,
                        showCursorWhenSelecting: true
                    }
                }
            },

            iconModal: {
                show: false
            },

            formatterModal: {
                show: false
            },

            sizeModal: {
                show: false
            },

            variants: [
                'primary',
                'secondary',
                'info',
                'danger',
                'warning',
                'success',
                'light',
                'dark'
            ],
            model: {
                title: '',
                description: '',
                type: '',
                component: '',
                formatter: {
                    code: 'return models.length;',
                    limit: -1,
                    filter: '',
                    filterOn: [],
                    disabled: false
                },
                variant: '',
                progressBar: {
                    bar: false,
                    variant: '',
                    formatter: ''
                },
                icon: {
                    type: '',
                    value: ''
                },
                size: {
                    sm: 3,
                    md: 3,
                    lg: 3
                },
                is_active: false
            },
            filterOnFields: [],

            libs: [
                {
                    name: "Lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                }
            ]
        }
    },
    watch: {
        model: {
            handler(val, old) {
                // match to remove error field
                if (val.type !== 'StandardFullIcon') {
                    this.errors = this.errors.filter(e => {
                        return e.field != 'icon_variant';
                    })
                }

                if (val.type == 'TextBox') {
                    this.errors = this.errors.filter(e => {
                        return e.field != 'component';
                    })
                }


                if (val.component != "") {
                    let settings = this.$store.getters.componentSettings(val.component)
                    this.filterOnFields = settings.settings.fields.map(f => {
                        return f.key;
                    })
                }
            },
            deep: true
        }
    },
    computed: {
        componentList() {
            let menu = deepCopyObject(this.$store.getters.componentsMenu)
            let filtered = menu.filter(m => {
                return m.is_active
            })

            filtered.map(m => {
                m.text = m.name
                m.value = m.uuid
            })

            return filtered
        },

        vars() {
            return [
                {
                    name: "models",
                    usage: this.modelFields()
                }
            ];
        }
    },

    methods: {
        save(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$mainDialog.msgBoxOk("Some fields are not valid!")

                return
            }

            this.$http.post("/v1/system/widget/create", this.model).then(resp => {

                this.$bvToast.toast("Widget created", {
                    variant: 'success',
                    title: "Success"
                })

                this.$store.commit("SET_WIDGET", resp.data);

                this.$router.push({ path: "/admin/widgets" });
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$mainDialog.msgBoxOk(error.response.data.message)
            })
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        modelFields() {
            let component = this.$store.getters.componentSettings(this.model.component)

            if (component !== undefined) {
                let fields = component.settings.fields

                let formated = {}

                fields.forEach(f => {
                    formated[f.key] = null

                    if (f.module == "input" || f.module == "textarea") {
                        formated[f.key] = ""

                        if (f.type == "number") {
                            formated[f.key] = 0
                        }
                    }
                })

                return '[' + JSON.stringify(formated) + ']'
            }

            return ''

        }
    },

    mounted() {
        this.modelFields()
    }
}
</script>
